import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { APIContext } from "src/components/Contexts/APIContext"
import QaiChallengeFilterViewModel from "./ViewModels/QaiChallengeFilterViewModel";
import getActiveFilterDateRangeFlag from "../../Utilities/DateRange";
import { QaiScorecardChallengeQuestionViewModel } from "./ViewModels/QaiScorecardChallengeQuestionsViewModel";

interface IQaiChallengeNotesHeaderProps {
    questionViewModel: QaiScorecardChallengeQuestionViewModel
    filters: QaiChallengeFilterViewModel
}

export default function QaiChallengeNotesHeader({ questionViewModel, filters }: IQaiChallengeNotesHeaderProps) {
    const { get } = useContext(APIContext);
    const [exampleCount, setExampleCount] = useState<number>(0)

    useEffect(() => {
        get('QaiScorecardChallenge',
            `GetExampleCount?questionId=${questionViewModel.questionId}`,
            (data) => setExampleCount(data))
    }, [])

    let exampleCallsLink = 'Search/SearchIndex'
        + `?client=${questionViewModel.client}`
        + `&templateId=${questionViewModel.templateId}`
        + `&sectionId=${questionViewModel.sectionId}`
        + `&questionId=${questionViewModel.questionId}`
        + `&dateRangeFlag=${getActiveFilterDateRangeFlag(filters)}`

    return (
        <Grid
            container size={12}
            justifyContent="space-between"
            height="5%">
            <Grid>
                <Typography variant="h5">QA/TL Notes</Typography>
            </Grid>
            <Grid size={4}>
                <Button
                    variant="contained"
                    href={exampleCallsLink}
                    fullWidth>
                    View example calls {
                        <Chip
                            label={exampleCount}
                            sx={{
                                height: '24px',
                                backgroundColor: '#cecece',
                                marginLeft: 1
                            }} />}
                </Button>
            </Grid>
        </Grid>
    )
}